import React from "react";

const ReceiptIcon = () => {
  return (
    <svg
      width="60"
      height="58"
      viewBox="0 0 68 68"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        x="1.36"
        y="1.36"
        width="65.28"
        height="65.28"
        rx="32.64"
        fill="white"
      />
      <rect
        x="1.36"
        y="1.36"
        width="65.28"
        height="65.28"
        rx="32.64"
        stroke="#696677"
        strokeWidth="1.28"
      />
      <path
        d="M37.5834 17.8333H23.4167C21.8519 17.8333 20.5834 19.1019 20.5834 20.6667V46.1667L24.125 43.3333L26.9584 46.1667L30.5 43.3333L34.0417 46.1667L36.875 43.3333L40.4167 46.1667V20.6667C40.4167 19.1019 39.1482 17.8333 37.5834 17.8333Z"
        stroke="#696677"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M26.25 23.5H34.75"
        stroke="#696677"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M26.25 29.1667H34.75"
        stroke="#696677"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M26.25 34.8333H27.6667"
        stroke="#696677"
        strokeWidth="2.83333"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default ReceiptIcon;
